// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Labels = require("../../reason/clients/components/Labels.bs.js");
var Scalars = require("../../scalars/Scalars.bs.js");
var UTCDate = require("../../reason/common/types/UTCDate.bs.js");
var DateFns = require("date-fns");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var OwnRentalPropertyStatusLabel_rentalPropertyV5_graphql = require("../../__generated__/OwnRentalPropertyStatusLabel_rentalPropertyV5_graphql.bs.js");

var convertFragment = OwnRentalPropertyStatusLabel_rentalPropertyV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, OwnRentalPropertyStatusLabel_rentalPropertyV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(OwnRentalPropertyStatusLabel_rentalPropertyV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, OwnRentalPropertyStatusLabel_rentalPropertyV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(OwnRentalPropertyStatusLabel_rentalPropertyV5_graphql.node, convertFragment, fRef);
}

var PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function OwnRentalPropertyStatusLabel$WithoutErrorBoundary(props) {
  var match = use(props.rentalProperty);
  var status = match.status;
  var isArchived;
  switch (status.__typename) {
    case "ActiveProperty" :
    case "__unselected" :
        isArchived = false;
        break;
    default:
      isArchived = status.archived;
  }
  if (isArchived) {
    return JsxRuntime.jsx(Labels.ArchivedLabel.make, {});
  }
  switch (status.__typename) {
    case "ActiveProperty" :
        if (!status.isRenewable) {
          return JsxRuntime.jsx(Labels.ActiveStatusLabel.make, {});
        }
        var daysLeft = DateFns.differenceInCalendarDays(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(status.activeUntil)), new Date());
        return JsxRuntime.jsx(Labels.ExpiringStatusLabel.make, {
                    expiringIn: Labels.stringOfExpiring(daysLeft)
                  });
    case "ExpiredProperty" :
        return JsxRuntime.jsx(Labels.ExpiredStatusLabel.make, {});
    case "RentedProperty" :
        return JsxRuntime.jsx(Labels.RentedLabel.make, {});
    case "WithdrawnProperty" :
        return JsxRuntime.jsx(Labels.WithdrawnLabel.make, {});
    case "__unselected" :
        return null;
    
  }
}

var WithoutErrorBoundary = {
  make: OwnRentalPropertyStatusLabel$WithoutErrorBoundary
};

function OwnRentalPropertyStatusLabel(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "property status",
              children: JsxRuntime.jsx(OwnRentalPropertyStatusLabel$WithoutErrorBoundary, {
                    rentalProperty: props.rentalProperty
                  })
            });
}

var make = OwnRentalPropertyStatusLabel;

exports.PropertyFragment = PropertyFragment;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* Labels Not a pure module */
